const defaultRules = {
  "letters": {
    "a": "a",
    "b": "b",
    "c": "ts",
    "ĉ": "cz",
    "d": "d",
    "e": "e",
    "f": "f",
    "g": "g",
    "ĝ": "dż",
    "h": "h",
    "ĥ": "ch",
    "i": "ij",
    "j": "y",
    "ĵ": "rz",
    "k": "k",
    "l": "l",
    "m": "m",
    "n": "n",
    "o": "o",
    "p": "p",
    "r": "r",
    "s": "s",
    "ŝ": "sz",
    "t": "t",
    "u": "u",
    "ŭ": "ł",
    "v": "w",
    "z": "z"
  },
  "fragments": [
    { "match": "tsx", "replace": "cz" },
    { "match": "gx", "replace": "dż" },
    { "match": "hx", "replace": "ch" },
    { "match": "yx", "replace": "rz" },
    { "match": "sx", "replace": "sz" },
    { "match": "ux", "replace": "ł" },
    { "match": "atsij", "replace": "atssij" },
    { "match": "ide\b", "replace": "ijde" },
    { "match": "io\b", "replace": "ijo" },
    { "match": "ioy\b", "replace": "ijoj" },
    { "match": "ioyn\b", "replace": "ijojn" },
    { "match": "feyo\b", "replace": "fejo" },
    { "match": "feyoy\b", "replace": "feyoj" },
    { "match": "feyoyn\b", "replace": "feyoj" },
    { "match": "^ekzij", "replace": "ekzji" },
    { "match": "tssijl", "replace": "tssil" },
    { "match": "ijuy", "replace": "iuyy" },
    { "match": "ijeh", "replace": "ije" },
    { "match": "sijlo", "replace": "ssilo" },
    { "match": "^sij", "replace": "syy" },
    { "match": "tsij", "replace": "tssij" },
    { "match": "sij", "replace": "ssij" },
    { "match": "sssij", "replace": "ssij" },
    { "match": "rijpozij", "replace": "ryypozyj" },
    { "match": "zijs", "replace": "zyjs" }
  ],
  "specialCases": {
    "ok": "ohk",
    "s-ro": "sjijnjoro",
    "s-ino": "sjijnjorijno",
    "ktp": "ko-to-po",
    "k.t.p": "ko-to-po",
    "atm": "antałtagmeze",
    "ptm": "posttagmeze",
    "bv": "bonvolu"
  },
  "numbers": {
    "0": "nulo",
    "1": "unu",
    "2": "du",
    "3": "trij",
    "4": "kvar",
    "5": "kvijn",
    "6": "ses",
    "7": "sep",
    "8": "ohk",
    "9": "nał",
    "10": "dek",
    "100": "tsent",
    "1000": "mijl",
    "1000000": "mijlijono"
  }
}

function handleSpecialCases(word){
  return defaultRules.specialCases[word];
}

function parseNumber(word){
  const parts = word.split(".");
  const integer = parseInt(parts[0]);
  const decimal = (parts[1] && parseInt(parts[1])) || 0;
  return [integer, decimal]
}

function transformNumToWords(word){
  const [integer, fraction] = parseNumber(word); 
  let result = transformNumPart(integer);
  if (fraction && fraction < 100)
    result = `${result} komo ${transformNumPart(fraction)}`
  return result;
}

function getNumberFromRules(number){
  return defaultRules.numbers[number];
}

function transcribeNumber(one, ten, hundred, includeOne){
    let result = "";

    if (hundred > 0) {
      if (hundred == 1) {
        result += ` ${getNumberFromRules(100)}`;
      } else {
        result += ` ${getNumberFromRules(hundred)} ${getNumberFromRules(100)}`
      }
    }

    if (ten > 0) {
      if (ten == 1) {
        result += ` ${getNumberFromRules(10)}`;
      } else {
        result += ` ${getNumberFromRules(ten)} ${getNumberFromRules(10)}`;
      }
    }

    if (one == 1) {
      if (includeOne) {
        result += ` ${getNumberFromRules(1)}`;
      }
    } else if (one != 0) {
      result += ` ${getNumberFromRules(one)}`;
    }

    return result.trim();
}

function transformNumPart(number){
  const ones = number % 10
  const tens = (number / 10) % 10
  const hundreds = (number / 100) % 10
  const thousands = (number / 1000) % 10
  const tenThousands = (number / 10000) % 10
  const hundredThousands = (number / 100000) % 10
  const millions = (number / 1000000) % 10
  const tenMillions = (number / 10000000) % 10
  const hundredMillions = (number / 100000000) % 10

  const first = transcribeNumber(ones, tens, hundreds, true)
  const second = transcribeNumber(thousands, tenThousands, hundredThousands, false)
  const third = transcribeNumber(millions, tenMillions, hundredMillions, false)

  const hasValues = (n1, n2, n3) => {
    return n1 != 0 || n2 != 0 || n3 != 0
  }

  let result = "";

  if (hasValues(millions, tenMillions, hundredMillions)) {
    result += `${third} ${getNumberFromRules(1000000)}`;
  }

  if (hasValues(thousands, tenThousands, hundredThousands)) {
    result += `${second} ${getNumberFromRules(1000)}`;
  }

  if (hasValues(ones, tens, hundreds)) {
    result += `${first}` 
  }

  return result.trim().replace(/,*$/, "");
}

export function transformEoToPl(text){
  text = text.replace("\n", " ").toLowerCase();
  const words = text.split(" ");

  const mappedWords = words.map(word=>{
    if (word === "") return;
    if (!isNaN(word)) return transformNumToWords(word);
    const specialCase = handleSpecialCases(word);
    if (specialCase) return specialCase;
    const letters = word.split("");
    const mappedLetters = letters.map(letter => {
      return defaultRules.letters[letter] || letter;
    })

    const mappedWord = mappedLetters.join("");

    return defaultRules.fragments.reduce((word, fragment)=>{
      return word.replace(fragment.match, fragment.replace)
    }, mappedWord)
  })
  
  return mappedWords.join(" ")
}